import "./index.d"

const toObj = (sdkAttributes: NetworkAttributes) => sdkAttributes.reduce((memo, f: FormAttribute) => {
    memo[f.key] = f
    return memo
}, {})

interface NetworkAttributes extends Array<any> {
    [index: number]: FormAttribute
}


export const networkAndroidAttributes: NetworkAttributes = [
    {
        key: 'nameEn',
        title: "英文名",
    },
    {
        key: 'nameCn',
        title: "中文名",
        hideInList: true,
        rules: [],
    },
    {
        key: 'remark_name',
        title: "备注（中文）",
        hideInList: true,
        rules: [],
    },
    {
        key: 'remark_name_en',
        title: "备注（英文）",
        hideInList: true,
        rules: [],
    },
    {
        key: 'adNetworkVersionName',
        title: '三方广告网络版本号',
        contentExtra: `例如：1.0.0，支持宏 \${{SDK_VERSION}}，多个版本号用，分隔`,
        rules: [
            {pattern: /^[^，]*$/, message: '多个版本号请使用英文逗号(,)分隔，不支持中文逗号'},
            {pattern: /^\d+(?:\.\d+)*(?:,\d+(?:\.\d+)*)*$/, message: '仅支持数字版本号，多个版本请用英文逗号分隔'}
        ],
    },
    {
        key: 'identification',
        title: "三方广告网络唯一标识",
        tip: '用于打包文件路径定位',
        placeholder: '用于打包文件路径定位',
        rules: [
            {required: true},
            {pattern: /^[a-zA-Z][a-zA-Z0-9_]*$/, message: '必须英文开头，只允许英文大小写、数字和下划线。'}
        ],
    },
    {
        key: 'uniqueNetworkId',
        title: '广告网络唯一标识',
        placeholder: '用于识别iOS和安卓端统一的广告网络',
        rules: [
            {required: true},
            {pattern: /^[a-zA-Z][a-zA-Z0-9_]*$/, message: '必须英文开头，只允许英文大小写、数字和下划线。'}
        ],
    },
    {
        key: 'sdkId',
        title: 'SDK ID',
        type: "hidden",
        hideInList: true,
    },
    
    {
        key: 'adapterVersionNameTemplate',
        title: 'adapter的版本号模板',
        hideInList: true,
        contentExtra: `支持宏 \${{SDK_VERSION}}`,
    },
    {
        key: 'adapterVersionName',
        title: 'adapter的版本号',
        hideInList: true,
        rules: [],
        contentExtra: '如留空，则默认从adapter版本号模板生成',
    },
    {
        key: 'adTypes',
        title: '广告类型',
        type: 'checkbox',
        values: 'adTypes'
    },
    {
        key: 'isHeaderBidding', // v0.8.5 新增
        title: 'Header Bidding 广告网络',
        type: 'radio',
        values: [{
            key: '1',
            title: '是'
        },{
            key: '0',
            title: '否'
        }],
        // defaultValue: '0',
    },
    {
        key: 'isAddCrossAndAdx', // v0.8.5 新增
        title: '自动打包',
        contentExtra: '选择“是”，则不显示在打包平台的广告网络选项中并自动打包',
        type: 'radio',
        values: [{
            key: '1',
            title: '是'
        },{
            key: '0',
            title: '否'
        }],
        defaultValue: '0',
    },
    {
        key: 'isCoppa', // v1.4.4 新增
        title: '是否支持儿童隐私协议',
        type: 'radio',
        values: [{
            key: '1',
            title: '是',
        },{
            key: '2',
            title: '否'
        }]
    },
    {
        key: 'region',
        title: "国内外",
        type: 'radio',
        values: [{
            key: '1',
            title: '国内'
        },{
            key: '2',
            title: '海外'
        }, {
            key: '0',
            title: '不限'
        }],
    },
    // {
    //     key: 'androidSupportCompatible',
    //     title: "androidSupport",
    //     type: 'radio',
    //     values: [{
    //         key: '1',
    //         title: '是'
    //     }, {
    //         key: '0',
    //         title: '否'
    //     }],
    // },
    // {
    //     key: 'androidXCompatible',
    //     title: "androidX",
    //     type: 'radio',
    //     values: [{
    //         key: '1',
    //         title: '是'
    //     }, {
    //         key: '0',
    //         title: '否'
    //     }],
    // },
    {
        key: 'isAndroidSupportOrX',
        title: "AndroidX/Support",
        type: 'radio',
        values: [{
            key: '1',
            title: 'Support'
        }, {
            key: '2',
            title: 'AndroidX'
        }, {
            key: '0',
            title: '不限'
        }],
    },
    {
        key: 'repositories',
        title: "仓库信息",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    {
        key: 'compileOptions',
        title: "编译选项",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    {
        key: 'dependencies',
        title: "依赖配置",
        hideInList: true,
        type: 'textarea',
        rules: [],
        contentExtra: `支持宏 \${{ADAPTER_VERSION}}，\${{AD_NETWORK_VERSION}}， \${{SDK_VERSION}}`,
    },
    {
        key: "nogradleDependencies", // v0.8.5 新增
        title: "非Gradle依赖配置",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    {
        key: 'androidManifest',
        title: "androidManifest片段",
        hideInList: true,
        type: 'textarea',
        rules: [],
    },
    // {
    //     key: 'filePath',
    //     title: "文件路径",
    //     hideInList: true,
    //     type: 'textarea',
    // }
]
export const networkAndroidAttribute = toObj(networkAndroidAttributes)


export const networkIosAttributes: NetworkAttributes = [
    {
        key: 'nameEn',
        title: "英文名",
    },
    {
        key: 'nameCn',
        title: "中文名",
        hideInList: true,
        rules: [],
    },
    {
        key: 'remark_name',
        title: "备注（中文）",
        hideInList: true,
        rules: [],
    },
    {
        key: 'remark_name_en',
        title: "备注（英文）",
        hideInList: true,
        rules: [],
    },
    {
        key: 'adNetworkVersionName',
        title: "三方广告网络版本号",
        contentExtra: `例如：1.0.0，支持宏 \${{SDK_VERSION}}，多个版本号用，分隔`,
        rules: [
            {pattern: /^[^，]*$/, message: '多个版本号请使用英文逗号(,)分隔，不支持中文逗号'},
            {pattern: /^\d+(?:\.\d+)*(?:,\d+(?:\.\d+)*)*$/, message: '仅支持数字版本号，多个版本请用英文逗号分隔'}
        ],
    },
    {
        key: 'identification',
        title: "三方广告网络唯一标识",
        tip: '用于打包文件路径定位',
        placeholder: '用于打包文件路径定位',
        rules: [
            {required: true},
            {pattern: /^[a-zA-Z][a-zA-Z0-9_]*$/, message: '必须英文开头，只允许英文大小写、数字和下划线。'}
        ],
    },
    {
        key: 'uniqueNetworkId',
        title: '广告网络唯一标识',
        placeholder: '用于识别iOS和安卓端统一的广告网络',
        rules: [
            {required: true},
            {pattern: /^[a-zA-Z][a-zA-Z0-9_]*$/, message: '必须英文开头，只允许英文大小写、数字和下划线。'}
        ],
    },
    {
        key: 'sdkId',
        title: "SDK ID",
        type: "hidden",
        hideInList: true,
    },
    
    {
        key: 'adTypes',
        title: '广告类型',
        type: 'checkbox',
        values: 'adTypes'
    },
    {
        key: 'podContent',
        title: "显示在pod中的内容",
        hideInList: true,
        type: 'textarea',
        contentExtra: `支持宏 \${{ADAPTER_VERSION}}，\${{AD_NETWORK_VERSION}`,
    },
    {
        key: 'is_spm_enabled',
        title: 'Swift Package Manager',
        type: 'radio',
        values: [{
            key: '1',
            title: '开启'
        }, {
            key: '0',
            title: '关闭'
        }],
        defaultValue: '0',
        contentExtra: '开启后该平台才显示在打包平台 SPM 列表',
    },
    {
        key: 'spm_support_version',
        title: 'SPM 版本',
        hideInList: true,
        rules: [],
        placeholder: '例如：1.0.0',
    },
    {
        key: 'spm_repo_link',
        title: 'SPM Repository 链接',
        hideInList: true,
        placeholder: 'https://github.com/...',
        rules: [{
            validator: (_rule: any, value: string) => {
                const trimmed = value?.trim() ?? ''
                if (!trimmed) {
                    return Promise.resolve()
                }
                if (/^https?:\/\/.+/.test(trimmed)) {
                    return Promise.resolve()
                }
                return Promise.reject(new Error('请输入有效的 URL（http/https）'))
            },
        }],
    },
    {
        key: 'isHeaderBidding', // v0.8.5 新增
        title: 'Header Bidding 广告网络',
        type: 'radio',
        values: [{
            key: '1',
            title: '是'
        },{
            key: '0',
            title: '否'
        }]
    },
    {
        key: 'isAddCrossAndAdx', // v0.8.5 新增
        title: '自动打包',
        contentExtra: '选择“是”，则不显示在打包平台的广告网络选项中并自动打包',
        type: 'radio',
        values: [{
            key: '1',
            title: '是'
        },{
            key: '0',
            title: '否'
        }],
        defaultValue: '0',
    },
]
export const networkIosAttribute = toObj(networkIosAttributes)